import { useEffect, useRef, useState } from 'react'

const useExpandableText = (text: string, maxLines: number) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [needsTruncation, setNeedsTruncation] = useState(false)
  const textRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = Number.parseInt(
        getComputedStyle(textRef.current).lineHeight
      )
      const maxHeight = lineHeight * maxLines
      setNeedsTruncation(textRef.current.scrollHeight > maxHeight)
    }
  }, [text, maxLines])

  const toggleExpand = () => setIsExpanded(!isExpanded)

  return {
    isExpanded,
    needsTruncation,
    textRef,
    toggleExpand
  }
}

export { useExpandableText }
